import React from 'react';

const CallToActionBanner = ({
  headline = 'Your founders deserve world-class support.',
  subtext = 'Partner with Yomuma Likessa to design a cohort experience that delivers measurable outcomes for every founder you back.',
  primaryText = 'Book Strategic Call',
  onPrimaryClick = () => {
    const contactSection = document.getElementById('hire');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}) => {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] opacity-95"></div>
      <div className="relative w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 text-center text-white">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
          {headline}
        </h2>
        <p className="text-base sm:text-lg lg:text-xl text-gray-200 max-w-3xl mx-auto mb-8">
          {subtext}
        </p>

        <div className="flex justify-center">
          <button
            onClick={onPrimaryClick}
            className="bg-accent-yellow text-gray-900 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-yellow-400 hover:scale-105 transition-all duration-200"
          >
            {primaryText}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CallToActionBanner;

